import { NetworkType } from "@/config";

// New Testnet Contract Addresses
// export const AccessControlManagerTestnet =
//   "0x87D3440372293aCf9149552546F7141AAe05Be91";
// export const TokenRegistryTestnet =
//   "0x032666197A5d9329e717800FC90E8C951bA12290";
// export const ProviderRegistryTestnet =
//   "0x7fDE3748e8AE27CaF506A47601acAf3B6AEaC34f";
// export const ProviderAttributeRegistryTestnet =
//   "0x87B49A9b928b06AA5782cB7ec495da8c507CaADC";
// export const FizzRegistryTestnet = "0x6057730B3B355A111061D63d2D7399D8d51aac58";
// export const FizzAttributeRegistryTestnet =
//   "0x24A05B480235Ccb450bf7Ce7e9F65072Ed732292";
// export const EscrowTestnet = "0x3854Be113E7B1C7fD8CF4805dF6c7f30d1FA1bC6";
// export const OrderRequestTestnet = "0x1fdf629E5A90eE4FAab1336a23c41A0Cab8CbA9d";
// export const ResourceManagerTestnet =
//   "0x270d622149F46fFc72A9fD5A8cF92D1FdE5AD5E0";
// export const ComputeLeaseTestnet = "0x9C0a16a41d2b0fFc14e6f20Da1368b1FD93bD7e5";
// export const BidTestnet = "0x27930D6ee40E8DB57c713f063f4a97dc37dC3ffb";
// export const ResourceRegistryCPUTestnet =
//   "0x67B8c2201Eef00d1a8193a2aF301312DD21a286B";
// export const ResourceRegistryGPUTestnet =
//   "0x2B73F279044347A3B6c9F122Ec6b479b6C2beAc9";
// export const ResourceRegistryFactoryTestnet =
//   "0xbb132eB1b36D87ef7Ac63c95c05a8a56eCDac3fd";
// export const ProviderRewardsManagerTestnet =
//   "0x53717Bc3Ba4F84Fd44501b23A92c1F1a3Fc148f0";
// export const FizzRewardsManagerTestnet =
//   "0x92991aCA11aDc8207a397A0bd3Cbc5C8E840b1A5";
// export const RewardTokenTestnet = "0xB28aA1E5074AE0222cf764e2934182775Ee7AB42";
// export const FizzNodeRewardTokenTestnet =
//   "0xA2400EFe3d7a9E2281F32A66Df18CFFE651c69f3";

// New Testnet Contract Addresses (New Base Sepolia)

export const AccessControlManagerTestnet =
  "0x87D3440372293aCf9149552546F7141AAe05Be91";
export const TokenRegistryTestnet =
  "0x032666197A5d9329e717800FC90E8C951bA12290";
export const ProviderRegistryTestnet =
  "0x038Eb8E227B287d7D42Cf404A07ACb5a7Df7645A";
export const ProviderAttributeRegistryTestnet =
  "0x63942fCb221aDF85ebdFc11a061D5eea2384f00A";
export const FizzRegistryTestnet = "0xe16c74C9dB46d437527B83F7A55cF65662Ee4CA3";
export const FizzAttributeRegistryTestnet =
  "0x8cA664043Bf767323d331D69841e525C2c878543";
export const EscrowUserTestnet = "0xb8ac4512852409c9b30f10844c3f0a61679fae66";
export const EscrowProtocolTestnet =
  "0xbEDE87cE3411F280B3Ed63027B45f73Cbcd1B441";
export const OrderRequestTestnet = "0xCe9787883b8f3785CCd8C8c3275B5F41068d670A";
export const ComputeLeaseTestnet = "0x70008e46550E628D50310330686A0bc692F722Fd";
export const BidTestnet = "0xe029A4f5e970c389Ca16e48600707496602af5Ed";
export const ResourceRegistryCPUTestnet =
  "0x67B8c2201Eef00d1a8193a2aF301312DD21a286B";
export const ResourceRegistryGPUTestnet =
  "0x2B73F279044347A3B6c9F122Ec6b479b6C2beAc9";
export const ProviderRewardsManagerTestnet =
  "0xe32279Bf9d47E20AEbb9ec04Ba5FB46536BA2aB5";
export const FizzRewardsManagerTestnet =
  "0xd653644FFD4ec06d173237FbA952C450A4973f5c";
export const RewardTokenTestnet = "0xB28aA1E5074AE0222cf764e2934182775Ee7AB42";
export const FizzNodeRewardTokenTestnet =
  "0xA2400EFe3d7a9E2281F32A66Df18CFFE651c69f3";

// New Testnet Token addresses
export const USDT = "0x96Ca5955F25648FB44C5D772BAdB4313000C66Fe";
export const USDC = "0x816413630c39780677E1584D4a6DbAFd76b161F7";
export const DAI = "0xcF5F08686dBE94B88b93FB2E8E5482A7f432C892";
export const WETH = "0xd74C08f8ffDF88C807367813Ad64a960618f4dcC";
export const CST = "0x8E5996A3963011Ca9dFa04E3CB773147F98C0e17";
export const SPON = "0x76e593392523243ACD38ceD87c2007F14483a86B";
export const uSPON = "0xed8f325cdc2ba7567395cb451a2ea8faf40e23d2";

// Base Mainnet Contract Addresses
export const AccessControlManagerMainnet =
  "0x2F6dE416a7AEED365bE49DeB931D263EC742605C";
export const TokenRegistryMainnet =
  "0xDCD3eeE9f5Fb828C4EaE14B8Fe2382c0dDD6de01";
export const ProviderRegistryMainnet =
  "0x79c892AE9D910bBeb81705960BA01706Bb2Af02e";
export const ProviderAttributeRegistryMainnet =
  "0x4149Ff1496AA74F7A59989eb5332946fEed22705";
export const FizzRegistryMainnet = "0x1071F508b68E9cf8f338170295C952BDF509AE4D";
export const FizzAttributeRegistryMainnet =
  "0xB7AbA489Fe9F0eB930b8d298eD5FE669611cbf79";
export const EscrowUserMainnet = "0x67Ad502B202Ac602C215B2Ba28689a71d03F9Ba4";
export const EscrowProtocolMainnet =
  "0x7381F084D31EF2F983c95572b7DD6Ee99eE03d8d";
export const OrderRequestMainnet = "0xC1A0AF3224465c2a5099C14c5A1A4f6680C30A86";
export const ResourceManagerMainnet =
  "0x270d622149F46fFc72A9fD5A8cF92D1FdE5AD5E0";
export const ComputeLeaseMainnet = "0x8A9f22D855bBE978C0D47De0963a3B15022E8ce0";
export const BidMainnet = "0x1582D6f9A7098B112dC76dd55a98d11d95f4702A";
export const ResourceRegistryCPUMainnet =
  "0x8Ac7BD17fA6E51E9719FaEfD8FD8Cc46ECAa93A9";
export const ResourceRegistryGPUMainnet =
  "0x360135261AB6CF9c9bBeF4c5d2B1fB9bb1671C8e";
export const ResourceRegistryFactoryMainnet =
  "0xF302Af7f042A6D2e6A4c1fF67e4f69109d8f4Fa0";
export const ProviderRewardsManagerMainnet =
  "0x20f2159b1082529089752Bce0549a649B0f0032C";
export const ProviderRewardCalculatorMainnet =
  "0xa8F2FaECaeCe5654DB1927437b10852dffE659F6";
export const FizzRewardsManagerMainnet =
  "0x8A01206Fd078Be34b28d689C92C1f2C05B3C641B";
export const RewardTokenMainnet = "0xA0c5ba7d9eccbE59000e8E67654CA5d867C6b401";
export const FizzNodeRewardTokenMainnet =
  "0xA2400EFe3d7a9E2281F32A66Df18CFFE651c69f3";

export const USDTMainnet = "0xF981a6AB8D09a636EC78395b02B1aC693a0C8307";

export const USDCMainnet = "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913";

export const uSPONMainnet = "0xBf0fA0461331d815A103e59929E5a19A48C30f5e";

export const SPONMainnet = "0x080D43c2164AFdBc3712422CE78Ab902ccaB5CA1";

export const addressMap: Record<NetworkType, Record<string, string>> = {
  testnet: {
    AccessControlManager: AccessControlManagerTestnet,
    TokenRegistry: TokenRegistryTestnet,
    ProviderRegistry: ProviderRegistryTestnet,
    ProviderAttributeRegistry: ProviderAttributeRegistryTestnet,
    FizzRegistry: FizzRegistryTestnet,
    FizzAttributeRegistry: FizzAttributeRegistryTestnet,
    Escrow: EscrowUserTestnet,
    EscrowProtocol: EscrowProtocolTestnet,
    OrderRequest: OrderRequestTestnet,
    ComputeLease: ComputeLeaseTestnet,
    Bid: BidTestnet,
    ResourceRegistryCPU: ResourceRegistryCPUTestnet,
    ResourceRegistryGPU: ResourceRegistryGPUTestnet,
    ProviderRewardsManager: ProviderRewardsManagerTestnet,
    FizzRewardsManager: FizzRewardsManagerTestnet,
    RewardToken: RewardTokenTestnet,
    FizzNodeRewardToken: FizzNodeRewardTokenTestnet,
    USDT: USDT,
    USDC: USDC,
    DAI: DAI,
    WETH: WETH,
    CST: CST,
    SPON: SPON,
    uSPON: uSPON,
  },
  mainnet: {
    AccessControlManager: AccessControlManagerMainnet,
    TokenRegistry: TokenRegistryMainnet,
    ProviderRegistry: ProviderRegistryMainnet,
    ProviderAttributeRegistry: ProviderAttributeRegistryMainnet,
    FizzRegistry: FizzRegistryMainnet,
    FizzAttributeRegistry: FizzAttributeRegistryMainnet,
    Escrow: EscrowUserMainnet,
    EscrowProtocol: EscrowProtocolMainnet,
    OrderRequest: OrderRequestMainnet,
    ResourceManager: ResourceManagerMainnet,
    ComputeLease: ComputeLeaseMainnet,
    Bid: BidMainnet,
    ResourceRegistryCPU: ResourceRegistryCPUMainnet,
    ResourceRegistryGPU: ResourceRegistryGPUMainnet,
    ResourceRegistryFactory: ResourceRegistryFactoryMainnet,
    ProviderRewardsManager: ProviderRewardsManagerMainnet,
    FizzRewardsManager: FizzRewardsManagerMainnet,
    RewardToken: RewardTokenMainnet,
    FizzNodeRewardToken: FizzNodeRewardTokenMainnet,
    USDT: USDTMainnet,
    USDC: USDCMainnet,
    uSPON: uSPONMainnet,
    SPON: SPONMainnet,
  },
};
